<template>
  <section class="section_5">
    <div class="container">
      <div class="section_5_heading">
        <h4 style="color: #28a745; font-weight: 800; cursor:pointer;">{{cmsData.customer_experiences_title}}</h4>
      </div>
      <div>
        <carousel v-if="bestReview.length > 0" :items="3" :autoplay="true" :nav="false" id="customers_review">
            <div class="item" v-for="data in bestReview" :key="data.id">
                <div class="review-content shadow">
                    <!-- <img src="../../assets/images/review.png" alt="" /> -->
                    <img :src="imagePath + data.reviewer_image" alt="" style="height: 115px !important; width: 115px !important; border-radius: 60px; border: 2px solid rgb(226, 180, 120); box-shadow: rgba(0, 0, 0, 0.28) 1px 4px 5px 0px;" />
                    <h5 class="pb-2 pt-3">{{ data.reviewer_name }}</h5>
                    <p class="mb-0 text-muted" style="padding-bottom: 25px; padding-left: 15px; padding-right: 15px;">
                        {{ data.reviewer_comment }}
                    </p>
                </div>
            </div>
        </carousel>
      </div>
    </div>
  </section>
</template>

<script>
import carousel from "vue-owl-carousel2";

export default {
    name: "CustomerExperience",
    props:['bestReview','cmsData'],
    components: {
        carousel
    },
    data() {
        return {
            customerExperiencesData: [],
            imagePath: this.$api + "upload/reviewer_image/"
        };
    }
};
</script>
